import React from 'react';
// material
import FormGroup from '@material-ui/core/FormGroup';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import IconButton from '@material-ui/core/IconButton';
import AccountCircle from '@material-ui/icons/AccountCircle';

const styles = {
  profileIcon: {
    fontSize: 32,
    color: '#627A96'
  }
}

interface HeaderNavProps {
  isAdmin: boolean;
  image?: string;
  onClick(route: string): void;
  onLogout(): void;
}

const HeaderNav: React.FC<HeaderNavProps> = (props) => {
    const [auth, setAuth] = React.useState(true);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      setAuth(event.target.checked);
    }
    
    const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
      setAnchorEl(event.currentTarget);
    }

    const handleClose = (route: string) => {
      setAnchorEl(null);
      props.onClick(route);
    }

    return (
      <div>
        <IconButton
          aria-label="account of current user"
          aria-controls="menu-appbar"
          aria-haspopup="true"
          onClick={handleMenu}
          color="inherit"
        >
          <AccountCircle style={styles.profileIcon}/>
        </IconButton>
        <Menu
          id="menu-appbar"
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          keepMounted
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={open}
          onClose={handleClose}
        >
          <MenuItem onClick={() => handleClose('/profile')}>Profile</MenuItem>
          {props.isAdmin &&
            <MenuItem onClick={() => handleClose('/admin')}>Admin</MenuItem>
          }
          <MenuItem onClick={() => handleClose('/campaigns')}>Campaigns</MenuItem>
          <MenuItem onClick={props.onLogout}>Logout</MenuItem>
    
        </Menu>
      </div>
    )
};
export default HeaderNav;


// WEBPACK FOOTER //
// ./src/components/header/ProfileMenu.tsx